import {useMemo} from 'react';
import {useAuth} from '../context/AuthContext';

interface Authentication {
    signIn: () => void;
    signOut: () => void;
}

export function useAuthentication() {
    const {user, token, logout} = useAuth();

    const authentication: Authentication = useMemo(() => ({
        signIn: () => {
            // Sign-in is handled by the Keycloak adapter (onLoad: 'login-required').
        },
        signOut: () => {
            logout();
        },
    }), [logout]);

    return {user, token, authentication};
}
